export const GENERAL_TAB_PARAM = "tab";

export const DEFAULT_GENERAL_TAB_ID = 0;

const TAB_SLUG_BY_ID: Record<number, string> = {
  0: "basic-details",
  1: "personal-details",
  2: "referral-info",
  3: "medical-notes",
};

const TAB_ID_BY_SLUG: Record<string, number> = Object.fromEntries(
  Object.entries(TAB_SLUG_BY_ID).map(([id, slug]) => [slug, Number(id)]),
);

export const resolveGeneralTabId = (
  slug: string | null | undefined,
  availableIds: number[],
) => {
  const id = slug ? TAB_ID_BY_SLUG[slug.toLowerCase()] : undefined;

  return id !== undefined && availableIds.includes(id)
    ? id
    : DEFAULT_GENERAL_TAB_ID;
};

export const generalTabSearch = (search: string, id: number) => {
  const params = new URLSearchParams(search);

  if (id === DEFAULT_GENERAL_TAB_ID) {
    params.delete(GENERAL_TAB_PARAM);
  } else {
    params.set(GENERAL_TAB_PARAM, TAB_SLUG_BY_ID[id]);
  }

  return params.toString();
};
